'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialWordpressOutline = function IoSocialWordpressOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 5c8.3 0 15 6.7 15 15 0 0.7-0.1 1.4-0.2 2-0.9 6.7-6.1 12-12.8 12.8-0.7 0.1-1.4 0.2-2 0.2-8.3 0-15-6.7-15-15s6.7-15 15-15z m-13.5 15c0 5.3 3.1 9.9 7.6 12.1l-6.4-17.6c-0.8 1.7-1.2 3.5-1.2 5.5z m15.2 13.4c1-0.2 1.9-0.4 2.8-0.7 0 0-0.1-0.1-0.1-0.2l-4.2-11.3-2.5 7.5-1.5 4.3c1.1 0.4 2.5 0.5 3.8 0.5 0.6 0 1.2-0.1 1.7-0.1z m0.2-19.7l4.8 14.5 1.3-4.5c0.7-1.7 1.1-3.2 1.1-4.4 0-1.6-0.6-2.7-1.1-3.7-0.7-1.1-1.4-2.1-1.4-3.2 0-1.2 1-2.3 2.3-2.3h0.2c-2.5-2.2-5.6-3.5-9.1-3.5-4.7 0-8.8 2.3-11.2 6 0.3 0 0.6 0.1 0.8 0.1 1.4 0 3.6-0.3 3.6-0.3 0.7-0.1 0.8 1.1 0.1 1.2 0 0-0.8 0.1-1.6 0.1l4.9 14.6 3-8.8-2.1-5.8c-0.7 0-1.4-0.1-1.4-0.1-0.7 0-0.6-1.3 0.1-1.2 0 0 2.2 0.3 3.5 0.3 1.4 0 3.6-0.3 3.6-0.3 0.7-0.1 0.8 1.1 0.1 1.2 0 0-0.7 0.1-1.5 0.1z m4.9 17.9c3.5-2 6-5.5 6.6-9.7 0-0.6 0.1-1.3 0.1-1.9 0-2.3-0.6-4.5-1.7-6.5 0.1 0.5 0.1 1 0.1 1.4 0 1.4-0.3 2.9-1 4.9l-3.1 8.8z' })
        )
    );
};

exports.default = IoSocialWordpressOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-wordpress-outline.js
// module id = 2723
// module chunks = 0